export default function Na({
  size,
  color,
  className = "",
  onClick = () => {},
  active = false,
}) {
  return (
    <svg
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "0.5s",
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        backgroundColor: active ? "#67686b" : "#ffffff",
        borderRadius: "50%",
      }}
      fill={active ? "#ffffff" : color}
      className={className}
      viewBox="0 0 64 64"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
    >
      <path
        stroke={active ? "#67686b" : color}
        strokeWidth="1"
        d="M32,3c16,0,29,13,29,29S48,61,32,61S3,48,3,32S16,3,32,3 M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32
			s32-14.3,32-32S49.7,0,32,0L32,0z"
      />

      <path
        stroke={active ? "#67686b" : color}
        strokeWidth="1"
        d="M25.6,39.3h-2.7l-7.1-11.7l-0.1,0v11.6h-2.7v-16h2.7L22.9,35l0.1,0V23.3h2.7V39.3z"
      />
      <path
        stroke={active ? "#67686b" : color}
        strokeWidth="1"
        d="M29.8,40.7h-2.4l6.3-17.3h2.4L29.8,40.7z"
      />
      <path
        stroke={active ? "#67686b" : color}
        strokeWidth="1"
        d="M46.9,35.6h-6.2l-1.3,3.7h-2.7l5.9-16h2.5l5.8,16h-2.7L46.9,35.6z M41.4,33.3h4.7l-2.3-6.8h-0.1L41.4,33.3z"
      />
    </svg>
  );
}
